module.exports = __webpack_public_path__ + "img/XPF.85a8936c.svg";